module.exports = __webpack_public_path__ + "static/media/img_calendar_PT.51aa8a57.png";